import type {TLocalizedValidationError} from 'typebox/error'
import {ErrorContext, ErrorSchema, Stack} from 'typebox/schema'
import {Locale} from 'typebox/system'
import type {StaticEncode, TSchema} from 'typebox'
import {Errors} from 'typebox/value'

export interface AotValidator<Type extends TSchema> {
  Check(value: unknown): value is StaticEncode<Type>
  Code(): string
  Errors(value: unknown): ReturnType<typeof Errors>
  FirstError?(value: unknown): TLocalizedValidationError | undefined
}

class FirstErrorContext extends ErrorContext {
  override AtCapacity() {
    return this.GetErrors().length > 0
  }
}

function firstError<Type extends TSchema>(type: Type, value: unknown): TLocalizedValidationError | undefined {
  const context = new FirstErrorContext()
  ErrorSchema(Stack({}, type), context, '#', '', type, value)
  const [error] = context.GetErrors()
  return error && {...error, message: Locale.Get()(error)}
}

export function createAotValidator<Type extends TSchema>(
  type: Type,
  check: (value: unknown) => boolean,
  code: string,
): AotValidator<Type> {
  return {
    Check(value): value is StaticEncode<Type> {
      return check(value)
    },
    Code() {
      return code
    },
    Errors(value) {
      return Errors(type, value)
    },
    FirstError(value) {
      return firstError(type, value)
    },
  }
}
